import { render, staticRenderFns } from "./DefaultGroup.vue?vue&type=template&id=03dc82c6&scoped=true"
import script from "./DefaultGroup.vue?vue&type=script&lang=js"
export * from "./DefaultGroup.vue?vue&type=script&lang=js"
import style0 from "./DefaultGroup.vue?vue&type=style&index=0&id=03dc82c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc82c6",
  null
  
)

export default component.exports